export default `
  /**
   *
   * Legacy Synapse color variables assigned with the new GoTo colors.
   * These are NOT affected by the selected COLOR THEME.
   *
   * */
  --synapse-color-white: var(--neutral-000);
  --synapse-color-almost-white: var(--neutral-050);
  --synapse-color-grey-lighter: var(--neutral-100);
  --synapse-color-grey-light: var(--neutral-200);
  --synapse-color-grey-middle: var(--neutral-300);
  --synapse-color-grey-dark: var(--neutral-600);
  --synapse-color-grey-darker: var(--neutral-700);
  --synapse-color-almost-black: var(--neutral-800);
  --synapse-color-black: var(--neutral-900);

  --synapse-color-primary: var(--neutral-900);
  --synapse-color-primary-lighter: var(--neutral-500);
  --synapse-color-primary-light: var(--neutral-600);
  --synapse-color-primary-middle: var(--neutral-900);
  --synapse-color-primary-dark: var(--neutral-800);
  --synapse-color-primary-darker: var(--neutral-700);

  --synapse-color-dark-darker: var(--neutral-300);
  --synapse-color-dark-dark: var(--neutral-200);
  --synapse-color-dark-middle: var(--neutral-000);
  --synapse-color-dark-light: var(--neutral-050);
  --synapse-color-dark-lighter: var(--neutral-100);

  --synapse-color-danger-1: var(--red-100);
  --synapse-color-danger-2: var(--red-200);
  --synapse-color-danger-3: var(--red-500);
  --synapse-color-danger-4: var(--red-600);
  --synapse-color-danger-5: var(--red-700);

  --synapse-color-utility-1: var(--avatar-color-22);
  --synapse-color-utility-2: var(--avatar-color-32);
  --synapse-color-utility-3: var(--avatar-color-42);
  --synapse-color-utility-4: var(--avatar-color-41);
  --synapse-color-utility-5: var(--avatar-color-52);
  --synapse-color-utility-6: var(--avatar-color-01);
  --synapse-color-utility-7: var(--avatar-color-12);
  --synapse-color-utility-8: var(--avatar-color-11);
  --synapse-color-utility-9: var(--avatar-color-21);
`;
